function csvToArray(str) {

    return str.split(',').filter(x => x !== '');
}

function hasTag(car, tag) {
    const titleElement = car.find('.js_vehicleTitle')[0];
    let title = '';

    if (titleElement) {
        title = titleElement.innerText.toLowerCase();
    }

    if (title) {
        return title.includes(tag);
    }

    return false;
}

function getTheCars() {

    return $('.js_vehicleCard');
}

function carMatchesSearchTag(car, searchTag, excludeTagsArray) {
    const hasSearchTag = hasTag(car, searchTag),
          hasExcludeTag = excludeTagsArray.find(tag => hasTag(car, tag));

    return hasSearchTag && !hasExcludeTag;
}

function carMatchesSearchTags(car, searchTagsArray, excludeTagsArray) {

    return searchTagsArray.find(tag => carMatchesSearchTag(car, tag, excludeTagsArray));
}

function filterCarsBySearchTag(cars, searchTag, excludeTagsArray) {

    return cars.filter(function() {
        return carMatchesSearchTag($(this), searchTag, excludeTagsArray);
    });
}

function filterCarsBySearchTags(cars, searchTagsArray, excludeTagsArray) {

    return cars.filter(function() {
        return carMatchesSearchTags($(this), searchTagsArray, excludeTagsArray);
    });
}

function getSearchTags(filter) {

    return filter.data("tags").toString().toLowerCase();
}

function getExcludeTags(filter) {

    return $(this).data("exclude-tags") ? $(this).data("exclude-tags").toString().toLowerCase() : '';
}

function hideUnpopulatedModelFilters(cars) {
    const filters = getModelFilterButtons();

    filters.each(function() {
        const filter = $(this),
              searchTagsArray = csvToArray(getSearchTags(filter)),
              excludeTagsArray = csvToArray(getExcludeTags(filter)),
              results = filterCarsBySearchTags(cars, searchTagsArray, excludeTagsArray);

        if (results.length > 0) {
            filter.show();
        } else {
            filter.hide();
        }
    });
}

function clearFinanceFilter() {
    const financeFilters = getFinanceFilters();

    $(this).removeClass("active");
    $(".monthlySelection").removeClass("inactive");
    $(".depositSelection").removeClass("inactive");

    financeFilters.val("");

    $(".foundPaymentCars").empty().hide();
    $(".allCars").show();
}

function searchPayments(allCars, searchValue, foundCars, paymentType) {
    allCars.each(function() {
        let element,
            number = 0;

        if (paymentType === "deposit") {
            element = $(this).find(".prices .lineOne");

            const textElement = element.data("deposit");

            if (textElement) {
                number = parseInt(textElement);
            }

            $(".monthlySelection").addClass("inactive");
            $(".depositSelection").removeClass("inactive");
        } else {
            element = $(this).find(".prices .lineTwo");

            const textElement = element.data("monthly");

            if (textElement) {
                number = parseInt(textElement);
            }

            $(".monthlySelection").removeClass("inactive");
            $(".depositSelection").addClass("inactive");
        }

        if (number < parseInt(searchValue)) {
            $(this).closest(".featuredItem").clone().appendTo(foundCars);
        }
    });

    lazyLoadedImages.update();

    setTimeout(function() {
        $(window).trigger('scroll');
    }, 500);
}

function removeDuplicated(foundCars) {
    const found = {};

    foundCars.find('.featuredItem').each(function() {

        if (found[$(this).attr('id')]) {
            $(this).remove();
        } else {
            found[$(this).attr('id')] = true;
        }
    });
}

function searchByTags(allCars, searchTag, foundCars, excludeTagsArray) {
    const results = filterCarsBySearchTag(allCars, searchTag, excludeTagsArray);

    results.each(function() {
        const car = $(this);
        car.closest("li").clone().appendTo(foundCars);
    });

    foundCars.find("li").removeAttr("style");
    lazyLoadedImages.update();

    setTimeout(function() {
        $(window).trigger('scroll');
    }, 500);
}

function getModelFilterButtons() {

    return $('.js_carFilter');
}

function getFinanceFilters() {

    return $(".js_paymentsFilter");
}

function getClearModelFilterButtons() {
    
    return $(".js_clearModelFilter");
}

function getClearFinanceFilterButtons() {

    return $(".js_clearFinanceFilter");
}

function getFilterTabs() {

    return  $(".js_browseTab");
}

function clearModelFilter(e) {
    e.preventDefault();

    const carsContainer = $(this).closest(".carsFilterContainer").find(".allCars"),
          foundCars = $(".foundCars"),
          clearModelFilterButtons = getClearModelFilterButtons(),
          modelFilterButtons = getModelFilterButtons();

    foundCars.empty();
    foundCars.hide();
    modelFilterButtons.removeClass("active");
    carsContainer.show();
    clearModelFilterButtons.addClass("active");
}

function changeFinanceFilter() {
    const paymentType = $(this).data("type"),
          carsContainer = $(this).closest(".carsFilterContainer").find(".allCars"),
          searchValue = $(this).val(),
          foundCars = $(".foundPaymentCars"),
          allCars = carsContainer.find(".featuredItem"),
          clearFinanceFilterButtons = getClearFinanceFilterButtons();

    foundCars.empty();

    if (paymentType === 'deposit') {
        $(".js_deposit").find('option[value=' + searchValue + ']').prop('selected', true);
    } else {
        $(".js_payments").find('option[value=' + searchValue + ']').prop('selected', true);
    }

    if (searchValue > 0) {
        searchPayments(allCars, searchValue, foundCars, paymentType);

        clearFinanceFilterButtons.addClass("active");

        carsContainer.hide();
        foundCars.show();
    } else {
        carsContainer.show();
        foundCars.hide();
    }

    if ($(".js_payments").val() === '' && $(".js_deposit").val() === '') {
        clearFinanceFilterButtons.click();
    }
}

function changeModelFilter(e) {
    e.preventDefault();

    const carsContainer = $(this).closest(".carsFilterContainer").find(".allCars"),
          searchTags = getSearchTags($(this)),
          excludeTags = getExcludeTags($(this)),
          foundCars = $(".foundCars"),
          allCars = carsContainer.find("li"),
          clearModelFilterButtons = getClearModelFilterButtons(),
          modelFilterButtons = getModelFilterButtons();

    foundCars.empty();
    modelFilterButtons.removeClass("active");

    if (!$(this).hasClass("active")) {
        const searchTagsArray = csvToArray(searchTags);
        const excludeTagsArray = csvToArray(excludeTags);

        $(this).addClass("active");
        $("." + $(this).data("id")).addClass("active");

        searchTagsArray.forEach(tag => searchByTags(allCars, tag, foundCars, excludeTagsArray));
        removeDuplicated(foundCars);
        foundCars.show();
        carsContainer.hide();
    } else {
        $(this).removeClass("active");
        $("." + $(this).data("id")).removeClass("active");
    }

    clearModelFilterButtons.removeClass("active");
}

function changeFilterTab() {
    const clearModelFilterButtons = getClearModelFilterButtons(),
          clearFinanceFilterButtons = getClearFinanceFilterButtons(),
          filterTabs = getFilterTabs();

    filterTabs.removeClass("active");
    $(this).addClass("active");
    $(".js_browseTab[data-type=" + $(this).data("type") + "]").addClass("active")

    $(".offerFilter").hide();
    $("." + $(this).data("type") + "Filter").show();

    clearModelFilterButtons.click();
    clearFinanceFilterButtons.click();
}

function getFilterParam(url) {
    const params = new URLSearchParams(url),
          filter = params.get('filter');


    if (filter) {
        return filter.replace('%20', ' ');
    }

    return '';
}

function modelFilterMatchesUrlFilterParam(index) {
    const urlFilterParam = getFilterParam(location.search),
          modelFilterParam = getFilterParam($(this).attr('href'));

    return modelFilterParam && (modelFilterParam == urlFilterParam);
}

function init() {
    'use strict';

    const financeFilters = getFinanceFilters(),
          modelFilterButtons = getModelFilterButtons(),
          clearFinanceFilterButtons = getClearFinanceFilterButtons(),
          clearModelFilterButtons = getClearModelFilterButtons(),
          filterTabs = getFilterTabs();

    hideUnpopulatedModelFilters(getTheCars());

    if (clearFinanceFilterButtons.length > 0) {
        clearFinanceFilterButtons.click(clearFinanceFilter);
    }

    if (clearModelFilterButtons.length > 0) {
        clearModelFilterButtons.click(clearModelFilter);
    }

    if (financeFilters.length > 0) {
        financeFilters.on('change', changeFinanceFilter);
    }

    if (filterTabs.length > 0) {
        filterTabs.click(changeFilterTab);
    }

    if (modelFilterButtons.length > 0) {
        modelFilterButtons.click(changeModelFilter);
        modelFilterButtons.filter(modelFilterMatchesUrlFilterParam).first().click();
    }
}

$(document).ready(init);
